import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Menu } from 'semantic-ui-react';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { SettingsAreaContext, menuClassNames } from '../../../cnr/contexts/SettingsAreaContext';
import { SettingsMenuContext } from '../../../cnr/contexts/SettingsMenuContext';
import { settingsAreaMenuHandlers, settingsAreaMenuInitialState, settingsAreaMenuReducer } from '../../../cnr/reducers/SettingsAreaMenuReducer';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import SearchMenu from '../../../components/menus/SearchMenu';
import DragDropSimple from '../../../dragNDrops/DragDropSimple';
import TransitionWrapper, { transitionWrapperTypes } from '../../../wrappers/TransitionWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import { useMenuGroupElements } from 'global/cnr/contexts/useHelpers/useMenuGroupElements';
import { SquaresWrapper } from 'global/wrappers/SquaresWrapper';

/**
* Creates a list of 'MenuItemsGroup' for each group in settingsGroupsByGroupType taken from settingsArea_state
* @param {*} group 
* @param {*} grpSettings 
* @param {*} inverse 
* @returns 
*/
const SettingsAreaGroupsMenu = () => {

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { appSettings_fns } = fns ?? {}
  const appUserAccess = useAppUserAccess()

  const { accessLevel: accessLevel_appUser } = appUserAccess ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext);
  const { settingsArea_state } = settingsAreaContext ?? {}
  const { settingsOptions, isGlobal, dndGroups, ddGroupsP, menuAuthGroups } = settingsArea_state ?? {}
  const { showHelpLine } = settingsOptions ?? {}

  // settingsMenuContext
  const settingsMenuContext = useContext(SettingsMenuContext);
  const { settingsMenu_state, settingsMenu_fns } = settingsMenuContext ?? {}
  const { appArea: appArea_sm, areaTypeSm, allowGroupMenuSort, showQuickSearch } = settingsMenu_state ?? {}

  // init
  const initState = settingsAreaMenuInitialState({ dndGroups })
  const [settingsAreaMenu_state, dispatch] = useReducer(settingsAreaMenuReducer, initState);
  const settingsAreaMenu_handlers = settingsAreaMenuHandlers(dispatch)

  // the menuItemElements is the content of the Menu.Item
  // const { menuItemElements } = settingsAreaMenu_state ?? {}

  const { menuItemElements, menuElementGroups } = useMenuGroupElements({ menuAuthGroups, accessLevel_appUser, settingsMenu_fns })

  useEffect(() => {
    if (menuItemElements && menuElementGroups) {
      settingsAreaMenu_handlers.handleSetElementGroups(menuItemElements, menuElementGroups, appArea_sm)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [menuElementGroups, menuItemElements]);

  useEffect(() => {
    if (allowGroupMenuSort) { settingsAreaMenu_handlers.handleAmmendDdGroups() }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [allowGroupMenuSort]);

  const handleUpdateGroupItemChange = (ddg) => settingsAreaMenu_handlers.handleUpdateGroupItemChange(ddg)

  const updateSettingsArea = () => {
    const dis = {}
    if (dndGroups) {
      Object.keys(dndGroups).forEach(groupKey => {
        const dndGroup = dndGroups[groupKey]
        if (dndGroup) {
          const { dataItems } = dndGroup
          if (dataItems) {
            dataItems.forEach(di => {
              dis[di.key] = {
                _position: di._position,
                settingsMenuGroupType: di.settingsMenuGroupType
              }
            })
          }
        }
      })
    }
    // setUpdating(true)
    const dataToUpdate = { ['settingsConsole.groupItemSettings']: dis }
    appSettings_fns.updateHomeGlobalSettingsToDb(dataToUpdate, null, appUserAccess)
  }

  const dropDownSimple = () => <DragDropSimple
    dndGroups={dndGroups}
    ddGroupsP={ddGroupsP}
    cn_portal={'msmi three menu-groups'}
    positionProp={'_position'}
    groupChangeKey={'settingsMenuGroupType'}
    handleUpdateGroupItemChange={handleUpdateGroupItemChange}
  />

  const wrapper_dropDownSimple = () => <Wrapper
    content={dropDownSimple()}
    footer={<UiSaveButtons save={{ oc: updateSettingsArea }} />}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const squaresWrapper = useMemo(() => {
    return <SquaresWrapper isGlobal={isGlobal} />
  }, [])

  let cn = menuClassNames.menu + ' three sagm'
  if (showHelpLine) { cn += ' hlp' }

  if (allowGroupMenuSort && dndGroups && isGlobal) {
    return wrapper_dropDownSimple()
  } else {
    // return squaresWrapper
    return menuItemElements ? <TransitionWrapper transitionWrapperType={transitionWrapperTypes.itemSimple}>
      <Menu borderless inverted={true} vertical fluid className={cn}>
        {showQuickSearch ? <SearchMenu /> : menuItemElements}
      </Menu></TransitionWrapper> : <div></div>
  }
};

export default SettingsAreaGroupsMenu